import CustomModal from '../../../../../components/Modal/CustomModal';
import {
    IconAvatarTable,
    IconEntryDevice,
    ImgCheckInHeader
} from '../../../../../components/buttons/IconButtons';
import CustomCard from '../../../../../components/CustomCard';
import CustomTooltip from '../../../../../components/CustomTooltip';
import React from 'react';
import {CheckInModalApp} from '../Functionality/CheckInModalApp';
import CustomAddChipSearch from '../../../../../components/CustomAddChipSearch';
import CustomDateTimePicker from '../../../../../components/CustomDateTimePicker';
import {CustomTextField} from '../../../../../components/CustomTextField';
import {equipmentListToLabel} from '../../../../../Apis/functions';
import {SERVICE_EQUIPMENT_NEVER_REGISTERED} from "../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 * Created At: 01 de diciembre de 2025
 */

const CheckInModal = (props) => {
    const { onHide, itemSelected } = props

    const {
        t,
        selectedList,
        setSelectedList,
        item,
        handleCreate,
        emptyFields
    } = CheckInModalApp({
        itemSelected,
        onHide
    });

    return (
        <CustomModal
            {...props}
            size='lg'
            display={'m-0px'}
            classNameBody="m-0 p-0"
            onHide={onHide}
            onConfirm={handleCreate}
            topLeftHeader={
                <div className={'d-flex align-items-center pt-2'}>
                    <IconEntryDevice className={'w-32px h-32px'}/>
                    <p className={'fs-modal-title ibl-font-w-600 font-color-general-950 ml-2 text-uppercase'}>{t('check_in')}</p>
                </div>
            }
        >
        <CustomCard classCard={'card-border-8px'} classContent={'p-0'}>
            <ImgCheckInHeader className={'w-100'}/>
            <div className={'row my-3'}>
                <div className={'col-12 d-flex justify-content-between'}>
                    <div className={'d-flex justify-content-start align-items-center'}>
                        <div><IconAvatarTable/></div>
                        <CustomTooltip
                            text={itemSelected?.userFullName}
                            classes={'text-capitalize font-color-general-950 fs-14px ml-2 text-ellipsis'}
                            showIfTruncated={true}
                        />
                    </div>
                </div>
            </div>

            <div className={'border-bottom-shades-300'}/>
            <div className={'row my-4'}>
                <div className='col-12'>
                    <CustomAddChipSearch
                        id="txt_cim_search_equipment"
                        selectedList={selectedList}
                        setSelectedList={setSelectedList}
                        label="equipment_material"
                        completeWidth={true}
                        sanitizeDataList={equipmentListToLabel}
                        emptyFields={emptyFields}
                        api={SERVICE_EQUIPMENT_NEVER_REGISTERED}
                        bodyApi={{ userId: itemSelected?.contractorId}}
                        required={false}
                        showSubSection={true}
                    />
                </div>
                <div className='col-12'>
                    <CustomTextField
                        id={'txt_cim_guard_name'}
                        value={item?.guardFullName}
                        disabled={true}
                        trans={'guard_name'}
                        required={true}
                    />
                </div>
                <div className='col-12'>
                    <CustomDateTimePicker
                        id={'dp_cim_date_time'}
                        name={'dateTime'}
                        disabled={true}
                        trans={'date_and_time'}
                        value={item?.accessDate}
                        required={true}
                    />
                </div>
            </div>
        </CustomCard>
        </CustomModal>
    );
};

export default CheckInModal
